// extracted by mini-css-extract-plugin
export var item = "PictoDetails-module--item--pqbUY";
export var items = "PictoDetails-module--items--YEU2t";
export var label = "PictoDetails-module--label--lNaJl";
export var picto = "PictoDetails-module--picto--WeEQe";
export var text = "PictoDetails-module--text--uKyCn";
export var texts = "PictoDetails-module--texts--xt7Ci";
export var title = "PictoDetails-module--title--O8oku";
export var wrapper = "PictoDetails-module--wrapper--1GInw";